import React from "react";

export const STATUS_OPTIONS = ["new", "in_progress", "resolved", "archived"];

const styles = {
  new: "bg-[#FFF0E6] text-[#B25A1E] border-[#FFD6BD]",
  in_progress: "bg-[#E8F0FB] text-[#2563B3] border-[#C3D9F6]",
  resolved: "bg-[#E6F6EC] text-[#15803D] border-[#BAE7C7]",
  archived: "bg-slate-100 text-slate-600 border-slate-200",
};

export default function StatusBadge({ status }) {
  const s = (status || "new").toLowerCase();
  const cls = styles[s] || styles.new;
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold border ${cls}`}>
      {s.replace(/_/g, " ")}
    </span>
  );
}
